import { useState, type FormEvent } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../auth/AuthProvider";
import { Button, Card, Field } from "../components/ui";
import { useTenantRuntime } from "../config/TenantRuntime";
import { env } from "../lib/env";

export function LoginPage() {
  const { user, signIn } = useAuth();
  const { tenant } = useTenantRuntime();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState(env.dataMode === "demo" ? "demo@yatta.com.br" : "");
  const [password, setPassword] = useState(env.dataMode === "demo" ? "demo" : "");
  const [submitting, setSubmitting] = useState(false);

  if (user) return <Navigate to="/" replace />;

  async function submit(event: FormEvent) {
    event.preventDefault();
    setSubmitting(true);
    try {
      await signIn(email, password);
      const target =
        (location.state as { from?: { pathname?: string } } | null)?.from?.pathname ?? "/";
      navigate(target, { replace: true });
    } catch (error) {
      toast.error(error instanceof Error ? error.message : "Não foi possível entrar.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="public-page login-page">
      <Card className="login-card">
        <form onSubmit={(event) => void submit(event)}>
          <p className="eyebrow">CRUZEIRO LIFE · YATTA TECNOLOGIA</p>
          <h1>{tenant.branding.shortName}</h1>
          <p>
            Uma solução Yatta Tecnologia para gestão de clientes, contratos, financeiro e
            benefícios.
          </p>
          {env.dataMode === "demo" ? (
            <>
              <div className="demo-warning" id="demo-access-notice" role="status">
                Ambiente de demonstração segura. Este acesso é fictício e não cria uma conta real.
                Não use dados pessoais ou senhas reais.
              </div>
              <p className="muted-text">Acesso sugerido: demo@yatta.com.br · senha demo</p>
            </>
          ) : (
            <p className="muted-text">Entre com as credenciais fornecidas pela sua organização.</p>
          )}
          <div className="form-section login-form">
            <Field label={env.dataMode === "demo" ? "E-mail de demonstração" : "E-mail"}>
              <input
                aria-describedby="demo-access-notice"
                autoComplete="username"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                type="email"
              />
            </Field>
            <Field label="Senha">
              <input
                aria-describedby="demo-access-notice"
                autoComplete="current-password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                type="password"
              />
            </Field>
            <Button disabled={submitting || !email.trim() || !password} type="submit">
              {submitting ? "Entrando…" : "Entrar"}
            </Button>
          </div>
        </form>
      </Card>
    </div>
  );
}
